var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Circle, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
var SvgHudLiveDot = function SvgHudLiveDot(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#hud-live-dot_svg__a)"
  }, /*#__PURE__*/React.createElement(Circle, {
    cx: 10,
    cy: 10,
    r: 4,
    fill: "#0CEB66"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)));
};
export default SvgHudLiveDot;